import { LightningElement, api } from "lwc";
import { c as classNames } from "tds/chunk_index";
import { assignedSlotNames } from "common/slot";

class layout extends LightningElement {
  @api variant = "main";
  slots = "";
  get className() {
    return classNames("layout", {
      "layout--header": this.showHeader,
      "layout--footer": this.showFooter,
      "layout--right-sidebar": this.variant === "right-sidebar",
      "layout--left-sidebar": this.variant === "left-sidebar",
      "layout--main": this.variant === "main",
    });
  }
  renderedCallback() {
    this.template.host.classList.add("layout--element");
  }
  get gridTemplateAreas() {
    const areas = [];
    if (this.showHeader) {
      areas.push("header");
    }
    areas.push("body");
    if (this.showFooter) {
      areas.push("footer");
    }
    return areas.map((a) => `"${a}"`).join(" ");
  }
  get gridTemplateAreasBodyStacked() {
    const areas = ["main"];
    if (/sidebar$/.test(this.variant)) {
      areas.push("sidebar");
    }
    return areas.map((a) => `"${a}"`).join(" ");
  }
  get computedStyles() {
    return `--grid-template-areas: ${this.gridTemplateAreas}; --grid-template-areas-body-stacked: ${this.gridTemplateAreasBodyStacked}`;
  }
  handleSlotChange() {
    this.slots = assignedSlotNames(this.template).join(" ");
  }
  @api handleChildFocus(event) {
    event?.stopPropagation();
    const filterSort = this.querySelector("lwc-tds-filter-sort");
    filterSort?.handleControlFocus();
  }
  get showHeader() {
    return this.slots.includes("header");
  }
  get showFooter() {
    return this.slots.includes("footer");
  }
  get showSidebar() {
    return this.variant !== "main";
  }
  get sidebarClassName() {
    return this.variant;
  }
}

export default layout;
